import { render } from "./RelationshipBoard.vue?vue&type=template&id=fa9981c2&scoped=true&ts=true"
import script from "./RelationshipBoard.vue?vue&type=script&lang=ts"
export * from "./RelationshipBoard.vue?vue&type=script&lang=ts"

import "./RelationshipBoard.vue?vue&type=style&index=0&id=fa9981c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9981c2"]])

export default __exports__